import React from 'react';
import { connect } from "react-redux";
import * as Tools from "../../../helpers/Tools";

class VideoVisitTips extends React.Component {
    constructor() {
        super();
        this.isMobile = Tools.isMobile();
    }
    render() {
        const { isMenuCollapsed } = this.props;
        return (<div className={`container-fluid body-content video-visit-tips-container`}>
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <h1 className="page-heading">Helpful Video Tips</h1>
                </div>
                <div className="col-12 maxWidth-content">
                    <ul className="angle-bullets">
                        <li>Ensure a quiet, well-lit and private location</li>
                        <li>Ensure a reliable wi-fi or cellular data connection in your location (cellular data usage and limits are per the respective user's data plan)</li>
                    </ul>
                </div>
            </div>
            {/*<div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="video-visit-tips__sub-note">
                        <div className="row">
                            <div className="col-12 col-md-7">
                                <div className="sub-heading"><span className="star">*</span> If connection issues persist</div>
                                <p>Using the menu in the bottom, right of the video frame, go to the video menu and select Manage Connection. Set the video to low resolution.</p>
                            </div>
                            <div className="col-12 col-md-5">
                                <img alt="Video Visit manage connection" src="/images/tips-image.jpg" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>*/}
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <ul className="angle-bullets">
                        <li>Try restarting your device or computer if you're experiencing issues</li>
                        <li>Ensure your device or computer is fully charged or plugged in</li>
                        <li>If possible, you may want to try a different device (smart phone, tablet, computer, etc.)</li>
                        <li>If your video disconnects you can reconnect through the same button</li>
                        {!this.isMobile &&
                            <li>Browser: Try Chrome for the best video experience</li>
                        }
                    </ul>
                </div>
            </div>
        </div>);
    }
}

const mapStateToProps = (state) => {
    return {        
        isMenuCollapsed: state.common.showCollapsedMenu
    };
};

export default connect(mapStateToProps, null)(VideoVisitTips);